const WHATSAPP = "972505887774";
const MESSAGE = "Hello, I came from the website. I would like to inquire more.";

export const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent(MESSAGE)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float-link"
  >
    <svg
      className="whatsapp-float-icon"
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M16.04 4.5c-6.36 0-11.54 5.04-11.54 11.24 0 2.1.6 4.15 1.74 5.92L4.7 27.5l6.08-1.48a11.8 11.8 0 0 0 5.26 1.24c6.36 0 11.54-5.04 11.54-11.24S22.4 4.5 16.04 4.5Zm0 20.72c-1.72 0-3.4-.45-4.86-1.3l-.34-.2-3.6.88.9-3.45-.23-.36a9.16 9.16 0 0 1-1.38-4.8c0-5.08 4.27-9.2 9.52-9.2 5.24 0 9.5 4.12 9.5 9.2 0 5.09-4.26 9.23-9.5 9.23Zm5.22-6.9c-.28-.14-1.68-.8-1.94-.9-.26-.09-.45-.14-.64.14-.19.27-.73.9-.9 1.08-.16.18-.33.2-.61.07-.28-.14-1.2-.43-2.28-1.37-.84-.73-1.4-1.64-1.57-1.91-.16-.28-.02-.43.13-.56.13-.13.28-.33.42-.49.14-.16.19-.28.28-.46.1-.18.05-.35-.02-.49-.07-.14-.64-1.5-.88-2.05-.23-.54-.47-.46-.64-.47h-.55c-.19 0-.49.07-.75.35-.26.27-.99.94-.99 2.3s1.01 2.67 1.15 2.85c.14.18 2 2.95 4.84 4.13.68.29 1.2.46 1.62.59.68.21 1.3.18 1.79.11.55-.08 1.68-.67 1.92-1.31.24-.65.24-1.2.17-1.31-.07-.12-.26-.19-.54-.33Z" />
    </svg>
  </a>
);
